const googleApiKey = "AIzaSyCPSLYne7V-Sv8zXaf57bxeynfhVfw-YbI"

export default googleApiKey
